// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"61189566","221":"eef308fd","326":"1bee56dc","345":"ddb7d174"}[chunkId] + ".chunk.css";
};